// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ptt-btn[data-v-c1180a1a] {
  position: relative;
  width: 75%;
  padding-bottom: 75%;
  margin: auto;
}
.ptt-btn .ptt-cont[data-v-c1180a1a] {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--ptt-bg-color);
  display: flex;
  box-shadow: var(--box-shadow);
  max-height: 320px;
}
.ptt-btn .ptt-cont .ptt-inner-cont[data-v-c1180a1a] {
  width: 90%;
  height: 90%;
  margin: auto;
  border-radius: 50%;
  display: flex;
  border: var(--border-width) solid var(--color);
}
.ptt-btn .ptt-cont .ptt-inner-cont i[data-v-c1180a1a] {
  margin: auto;
  font-size: 28px;
  opacity: 0.5;
  color: var(--color);
}
.ptt-btn .ptt-cont .ptt-inner-cont i.fa-microphone-slash[data-v-c1180a1a] {
  color: red;
}
.ptt-btn .slot[data-v-c1180a1a] {
  position: absolute;
}
.ptt-btn .bottom-left[data-v-c1180a1a] {
  bottom: 0;
  transform: translate(-50%, 50%);
}
.ptt-btn .top-left[data-v-c1180a1a] {
  top: 0;
  transform: translate(-50%, -50%);
}
.ptt-btn .top-right[data-v-c1180a1a] {
  right: 0;
  transform: translate(50%, -50%);
}
.ptt-btn .bottom-right[data-v-c1180a1a] {
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%);
}
@media (max-height: 700px) {
.ptt-btn[data-v-c1180a1a] {
    width: 65% !important;
    padding-bottom: 65% !important;
}
}
@media (max-height: 600px) {
.ptt-btn[data-v-c1180a1a] {
    width: 55% !important;
    padding-bottom: 55% !important;
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/radio/PttButton.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,MAAM;EACN,gCAAgC;AAClC;AACA;EACE,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,QAAQ;EACR,8BAA8B;AAChC;AACA;AACA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;AACA;AACA;AACA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;AACA","sourcesContent":[".ptt-btn[data-v-c1180a1a] {\n  position: relative;\n  width: 75%;\n  padding-bottom: 75%;\n  margin: auto;\n}\n.ptt-btn .ptt-cont[data-v-c1180a1a] {\n  position: absolute;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: var(--ptt-bg-color);\n  display: flex;\n  box-shadow: var(--box-shadow);\n  max-height: 320px;\n}\n.ptt-btn .ptt-cont .ptt-inner-cont[data-v-c1180a1a] {\n  width: 90%;\n  height: 90%;\n  margin: auto;\n  border-radius: 50%;\n  display: flex;\n  border: var(--border-width) solid var(--color);\n}\n.ptt-btn .ptt-cont .ptt-inner-cont i[data-v-c1180a1a] {\n  margin: auto;\n  font-size: 28px;\n  opacity: 0.5;\n  color: var(--color);\n}\n.ptt-btn .ptt-cont .ptt-inner-cont i.fa-microphone-slash[data-v-c1180a1a] {\n  color: red;\n}\n.ptt-btn .slot[data-v-c1180a1a] {\n  position: absolute;\n}\n.ptt-btn .bottom-left[data-v-c1180a1a] {\n  bottom: 0;\n  transform: translate(-50%, 50%);\n}\n.ptt-btn .top-left[data-v-c1180a1a] {\n  top: 0;\n  transform: translate(-50%, -50%);\n}\n.ptt-btn .top-right[data-v-c1180a1a] {\n  right: 0;\n  transform: translate(50%, -50%);\n}\n.ptt-btn .bottom-right[data-v-c1180a1a] {\n  bottom: 0;\n  right: 0;\n  transform: translate(50%, 50%);\n}\n@media (max-height: 700px) {\n.ptt-btn[data-v-c1180a1a] {\n    width: 65% !important;\n    padding-bottom: 65% !important;\n}\n}\n@media (max-height: 600px) {\n.ptt-btn[data-v-c1180a1a] {\n    width: 55% !important;\n    padding-bottom: 55% !important;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
